import { store } from '../../Store';

export const getLanguage = () => {
    const lang =
        store.getState().reducer.language || navigator.language.split('-')[0];

    return lang;
};

export const wrapWithDelay = (promise, minDelay = 0) => {
    let timeStart = new Date().getTime();

    return promise.then((data) => {
        return new Promise((res) => {
            let timeEnd = new Date().getTime();

            let timeDifference = timeEnd - timeStart;

            if (timeDifference >= minDelay) {
                res(data);
            } else {
                setTimeout(() => {
                    res(data);
                }, minDelay - timeDifference);
            }
        });
    });
};
